export default __webpack_public_path__ + "static/media/logo-hoz_black.738354a5.png";